import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { NationalModifiersDetails, NationalModifiersSelection } from '../types/nationalModifiers.types';
import { useSTKContext } from '../context/context';

export const useNationalModifiers = (enabled: boolean) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<NationalModifiersDetails[]>>({
    queryKey: ['nationalModifiers'],
    queryFn: () => apiClient.get<NationalModifiersDetails[]>('/nationalmodifiers'),
    enabled,
  });
};

export const useUpdateNationalModifiersLock = () => {
  const { apiClient } = useSTKContext();
  return useMutation({
    mutationFn: (requestBody: NationalModifiersSelection[]) => apiClient.put('/nationalmodifiers/update', requestBody),
  });
};

export const identicalArrays = (originalData: NationalModifiersDetails[], currentData: NationalModifiersDetails[]) => {
  let identicalData = true;
  const stringToBoolean = (string: string | boolean) => (string === 'false' ? false : !!string);
  if (currentData === originalData) {
    identicalData = true;
  }
  if (currentData.length !== originalData.length) {
    return false;
  }
  for (let i = 0; i < currentData.length; i += 1) {
    const newBoolean = stringToBoolean(currentData[i].isLock);
    if (newBoolean !== originalData[i].isLock) {
      return false;
    }
  }
  return identicalData;
};
